import { AbstractControl, FormGroup } from '@angular/forms';
import { FormGroupHelper } from './FormGroupHelper';
import { patchObject } from '../../app/shared/util/object-util';

export interface IGenericBaryFormGroup<CtrlType> {
  name: string;
  updated: boolean;
  controls: CtrlType;

  updateForm(model: any): void;

  updateModel(model: any): void;

  validateForm(): boolean;

  focusOnFirstError(): void;

  getAngularForm(): FormGroup;

  value(): any;
}

export class GenericBaryFormGroup<
    CtrlType extends {
      [key: string]: AbstractControl;
    }
  >
  extends FormGroupHelper
  implements IGenericBaryFormGroup<CtrlType>
{
  protected declare form: FormGroup;
  updated = false;
  controls: CtrlType;
  name: string;

  constructor(name: string, controls: CtrlType, validators?: any) {
    super();
    this.form = this.newFormGroup(controls, validators);
    this.controls = controls;
    this.name = name;
  }

  value(): any {
    return this.form.value;
  }

  updateForm(model: any): void {
    this.form.patchValue(model);
    this.updated = true;
  }

  updateModel(model: any): void {
    patchObject(model, this.form.value);
  }

  getAngularForm(): FormGroup {
    return this.form;
  }
}
